import { defineEvent } from '../types/event';
export var QBS_TIER_SELECT = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            transform: function (input) { return ({
                eventName: "QBS_Tier_".concat(input.tierIndex)
            }); }
        }
    ]
});
